
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire95b8"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire95b8"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
//////////////////////////////////////////
// Code for Guestbook operation
//////////////////////////////////////////

var $fmRoT = parcelRequire("fmRoT");
const $b97cdc2ff446e5f3$var$form = document.getElementById('inputForm');
//const eMail = document.getElementById('email');
const $b97cdc2ff446e5f3$var$comment = document.getElementById('comment');
const $b97cdc2ff446e5f3$var$guestBook = document.getElementById('guestBook');
const $b97cdc2ff446e5f3$var$closeBtn = document.getElementById('gbClose');
$b97cdc2ff446e5f3$var$form.addEventListener('submit', (event)=>{
    //console.log('clicked guestbook submit');
    // Get the text from the guestbook form
    const comment = $b97cdc2ff446e5f3$var$form.elements['comment'];
    //console.log('comment=', comment.value);
    // Need to get name of open trip
    const openItem = document.getElementsByClassName('item open');
    const destination = openItem[0].getElementsByClassName('destination');
    //console.log('text=', destination[0].innerText);
    // Prepare to database guestbook.  NOTE: activePhoto fullName, email and notify are no longer used
    const guestbookEntry = {
        comment: comment.value,
        activeTrip: destination[0].innerText,
        activePhoto: 'none specific',
        fullName: 'N/A',
        email: 'N/A',
        notify: false
    };
    //console.log('guestbookEntry=', guestbookEntry);
    $b97cdc2ff446e5f3$var$createTripGuestbook(guestbookEntry);
    // Hide the guestbook
    $b97cdc2ff446e5f3$var$guestBook.style.display = 'none';
    event.preventDefault();
});
//Intercep any enter keys
const $b97cdc2ff446e5f3$var$formElement = document.getElementById('inputForm');
$b97cdc2ff446e5f3$var$formElement.addEventListener('keypress', (event)=>{
    if (event.key === 'Enter') // key code of the keybord key
    //console.log('inputForm=', event.key);
    event.preventDefault();
});
// Clear comment box
// Clear the textarea when user focuses it for a fresh start
$b97cdc2ff446e5f3$var$comment.addEventListener('focus', (event)=>{
    try {
        $b97cdc2ff446e5f3$var$comment.value = '';
    } catch (e) {
    /* ignore if element type doesn't support value */ }
});
$b97cdc2ff446e5f3$var$closeBtn.addEventListener('click', (event)=>{
    //console.log('clicked close button');
    $b97cdc2ff446e5f3$var$guestBook.style.display = 'none';
});
// Save update note in Guestbook database
async function $b97cdc2ff446e5f3$var$createTripGuestbook(guestbookNew) {
    //console.log('guestbookNew=', guestbookNew);
    await (0, $fmRoT.default)({
        method: 'post',
        //url: 'http://127.0.0.1:3000/api/v1/guestbooks',
        url: 'https://safe-journey-35449.herokuapp.com/api/v1/guestbooks',
        data: {
            guestbookNew: guestbookNew
        }
    });
}


//# sourceMappingURL=repo.b36dd789.js.map
